import { cSidebar }     from "../sidebar/sidebar";
import { cAccountMenu } from "./account-menu/account-menu";
import { cTopSearch }   from "./top-search/top-search";

export class cHeader {
  body = document.querySelector('body') as HTMLElement;

  topSearch   : cTopSearch;
  accountMenu : cAccountMenu;
  sidebar     : cSidebar;

  constructor() {

    this.topSearch   = new cTopSearch(this);
    this.accountMenu = new cAccountMenu(this);
    this.sidebar     = new cSidebar(this);

    this.body.addEventListener('click', (e) => {
      this.closeAll();
    });
  }

  closeAll() {
    this.accountMenu.close();
    this.topSearch.close();
    this.sidebar.close();
  }

}